/* EditorGroupsComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./EditorGroupsRenderer");

class EditorGroupsComponent extends EventEmitter {
    constructor(entitySchemaObject, pristineValue, userSession, nibApiService, parentViewElement) {
        super(entitySchemaObject, pristineValue, userSession, nibApiService);
        this._userSession = userSession;
        this._nibApiService = nibApiService;
        this._pristineValue = pristineValue || {};
        this._parentViewElement = parentViewElement || "device-details-view-gl";
        this._renderer = new Renderer(this, entitySchemaObject);
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(() => {
            this._renderer = undefined;
        });
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    emitFormsPendingPatchesChanged() {
        this.emit("PendingPatchesChanged");
    }

    setFormPristineValues(val) {
        this.emit("SetFormPristineValue", val);
    }

    setEntitySchemaObject(entitySchemaObj) {
        this.emit("SetEntitySchemaObject", entitySchemaObj);
    }

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}
module.exports = EditorGroupsComponent;
